<template>
    <v-dialog v-model="show" max-width="1200">
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on"></slot>
        </template>
        <v-card :disabled="loading" :loading="loading">
            <v-card-title>Export invoices</v-card-title>
            <v-card-text>
              <v-simple-table v-if="formattedInvoices.length > 1">
                <tbody>
                  <tr>
                    <th v-for="value in formattedInvoices[0]">{{value}}</th>
                  </tr>
                  <tr v-for="(items, index) in formattedInvoices">
                    <td v-if="index > 0" v-for="item in items">{{item}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-alert v-else type="info" dense>No invoices to export</v-alert>
<!--                <v-data-table-->
<!--                        :loading="loading"-->
<!--                >-->
<!--                </v-data-table>-->
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="exportInvoices">export</v-btn>
                <v-btn color="success" @click="save">Mark invoices as EXPORTED</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ExportInvoices",
        data: () => ({
            show: false,
            loading: false,
            invoices: [],
        }),
        watch:{
          show(v){
            if(v && !this.loading){
              this.loadInvoices()
            }
          }
        },
        mounted(){
            this.loadInvoices();
        },
        computed:{
            formattedInvoices(){
                let invoices = [['Customer','Invoice Date','Due Date','Invoice','Service Date','Product/Service','Qty','Rate','Total', 'Description']]
                this.invoices.forEach(invoice => {
                    let items = invoice.invoice_items.map(item => {
                        return [
                            this.$store.$db().model('names').query().where('customer_id', invoice.customer_id).where('name_type_id', 1).first().name,
                            invoice.invoice_date,
                            invoice.due_date,
                            invoice.invoice_id,
                            invoice.invoice_date,
                            item.service,
                            item.quantity,
                            item.rate,
                            item.total,
                            item.description
                        ]
                    })
                    invoices.push(...items)
                })
                return invoices;
            }
        },
        methods:{
            async loadInvoices(){
                this.loading =true;
                this.invoices = [];
                let invoiceQuery = await this.$firestore.collection('invoices').where('exported', '==', false).get();
                if(invoiceQuery.docs.length > 0){
                  invoiceQuery.docs.forEach(doc => {
                    this.invoices.push({
                      ...doc.data(),
                      ref: doc.ref,
                    })
                  })
                }
                this.loading = false
            },
            exportInvoices(){
                let csvContent = "data:text/csv;charset=utf-8,"
                    + this.formattedInvoices.map(e => e.join(",")).join("\n");
                let encodedUri = encodeURI(csvContent);
                let link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "INVOICE_EXPORT.csv");
                document.body.appendChild(link); // Required for FF

                link.click();
            },
            async save(){
              this.loading = true;
                const invoices = this.invoices;
                let batch = this.$firestore.batch();
                invoices.forEach(invoice => {
                  batch.update(invoice.ref, {exported: true})
                })
                await batch.commit()
                this.$store.dispatch("showSuccess", "Invoices marked as 'EXPORTED'")
              this.loading = false;
                this.loadInvoices().catch(() => this.loading = false)
            }
        }
    }
</script>

<style scoped>

</style>
